// extracted by css-extract-rspack-plugin
export default {"loader":"zwGsQ5","spin":"XFF8a3","iconComplete":"BNenje","iconError":"S9nG3k"};